import { useLayoutData } from '@/contexts/layout'
import { MODAL_ID } from '@/constants/modalId'
import { showModal } from '@/components/Modals/ModalV2'
import { pluralize } from '@/util/stringHelpers'
import { SelectionToolbar } from './SelectionToolbar'
import { isTransferring } from '@/util/inventoryHelpers'
import { UserAssets } from '@/api/resources/user/assets/get/schema'
import { SEARCH_PARAMS } from '@/constants/searchParams'
import useUpdateInventoryQuery from '@/hooks/useUpdateInventoryQuery'
import { isTransferable } from '@/util/assetHelpers'

export const TransferBar = ({ loadedAssets }: { loadedAssets: UserAssets }) => {
  const { selectedAssets, updateSelectedAssets } = useLayoutData()
  const { update } = useUpdateInventoryQuery()

  const handleDeselectAll = () => {
    update({
      type: 'reset',
      parameters: [SEARCH_PARAMS.ASSET_SELECTION_MODE]
    })
    updateSelectedAssets([])
  }

  const handleSelectAll = () => {
    const newSelectedAssets = []
    loadedAssets
      .filter(
        ({ transferable, chain_status_text }) =>
          transferable && !isTransferring(chain_status_text)
      )
      .forEach(inventory => newSelectedAssets.push(inventory))
    updateSelectedAssets([...newSelectedAssets])
  }

  const handleOpenTransferModal = () => {
    showModal(MODAL_ID.transfer.review)
  }

  const selectedCount = selectedAssets.transfer.length
  const selectableCount = loadedAssets.filter(isTransferable).length

  return (
    <SelectionToolbar
      onCancel={handleDeselectAll}
      onSelectAll={handleSelectAll}
      value={{
        label: 'Item',
        component: (
          <>
            <span className="pricing-xl tabular-nums">{selectedCount}</span>{' '}
            <span className="text-gray-300">
              {pluralize('Item', selectedCount)}
            </span>
          </>
        )
      }}
      primaryAction={{
        label: 'Transfer',
        theme: 'white',
        onClick: handleOpenTransferModal
      }}
      selectedCount={selectedCount}
      selectableCount={selectableCount}
    />
  )
}
